import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {BooleanApiData, ChangeDocumentStatusRequest, DocumentDTO} from '../../api/data-contracts'
import {closeAreYouSureModal, openAreYouSureModal, postRequestAsync} from '../../redux/commonSlice'
import {getDocumentState, loadDocuments} from '../../redux/documentSlice'
import Translator from '../common/translate/Translator'
import {Api_Document_SetDocumentStatus} from '../../apiClient/apiClient'

function DocumentApprovalButtons(props: {document: DocumentDTO}) {
  const dispatch = useDispatch()
  const documentState = useSelector(getDocumentState)

  async function setDocumentStatusToSuccess(documentId: string) {
    const body: ChangeDocumentStatusRequest = {
      documentId: documentId,
      statusId: 2,
      statusMessage: 'Onaylandı',
    }

    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Document_SetDocumentStatus,
        body: body,
      })
    )
      .unwrap()
      .then(async (response: BooleanApiData) => {
        await dispatch<any>(loadDocuments())
        dispatch(closeAreYouSureModal())
      })
  }

  async function setDocumentStatusToDeny(documentId: string) {
    const body: ChangeDocumentStatusRequest = {
      documentId: documentId,
      statusId: 3,
      statusMessage: 'Onaylanmadı',
    }

    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Document_SetDocumentStatus,
        body: body,
      })
    )
      .unwrap()
      .then(async (response: BooleanApiData) => {
        await dispatch<any>(loadDocuments())
        dispatch(closeAreYouSureModal())
      })
  }

  return (
    <>
      <div className='row px-1'>
        <div className='col-6 px-0 d-flex justify-content-center'>
          {(props.document.approvalStatusId === 1 || props.document.approvalStatusId === 3) && (
            <a
              type='button'
              onClick={() => {
                setDocumentStatusToSuccess(props.document.guid ?? '')
              }}
              className='btn btn-sm btn-icon btn-light btn-success'
            >
              <i className='bi bi-hand-thumbs-up-fill fs-5'></i>
            </a>
          )}
        </div>
        <div className='col-6 px-0 d-flex justify-content-center'>
          {(props.document.approvalStatusId === 1 || props.document.approvalStatusId === 2) && (
            <a
              type='button'
              onClick={() => {
                setDocumentStatusToDeny(props.document.guid ?? '')
              }}
              className='btn btn-sm btn-icon btn-light btn-danger'
            >
              <i className='bi bi-hand-thumbs-down-fill fs-5'></i>
            </a>
          )}
        </div>
      </div>
    </>
  )
}

export default DocumentApprovalButtons
